/* eslint-disable max-lines-per-function */
import z from 'zod';
import { markierungTypes } from '@/domain/termine/shared/types/Markierung';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { TerminWiederholung } from '@/domain/termine/shared/types';
import dayjs from 'dayjs';
import {
  acceptedImageTypes,
  maxFileSize,
} from '@/domain/termine/shared/utils/fileUploadConfig';

export function UpdateFormValidationSchema() {
  const { t } = useTranslation();

  const validation = useMemo(() => {
    const regExDateTime = /^([01]\d|2[0-3]):([0-5]\d)$/;

    return z
      .object({
        id: z.string(),
        titel: z.string().min(1, t('domain.termine.sheet.validation.titel')),
        datum: z.string(),
        markierung: z.enum(markierungTypes),

        terminBild: z
          .object({
            file: z
              .instanceof(File)
              .refine((file) => file.size <= maxFileSize, {
                message: t('domain.termine.upload.error.size', {
                  maxFileSize: maxFileSize / 1024 / 1024,
                }),
              })
              .refine((file) => acceptedImageTypes.includes(file.type), {
                message: t('domain.termine.upload.error.fileType'),
              })
              .optional(),
            name: z.string().optional(),
            contentType: z.string().optional(),
            url: z.string().optional(),
            thumbnailUrl: z.string().optional(),
            standortId: z.string().optional(),
          })
          .optional(),
        beginn: z
          .string()
          .optional()
          .refine((val) => !val || val.length < 5 || regExDateTime.test(val)),
        ende: z
          .string()
          .optional()
          .refine((val) => !val || val.length < 5 || regExDateTime.test(val)),
        beschreibung: z.string().optional(),
        specials: z.string().optional(),
        wiederholung: z.enum(TerminWiederholung),
        wiederholungBis: z.string().optional(),
        terminKalenderId: z.string().optional(),
      })
      .refine(
        (data) => {
          if (data.wiederholung === TerminWiederholung.OHNE) return true;
          if (!data.wiederholungBis) return true;
          const bis = dayjs(data.wiederholungBis);
          const datum = dayjs(data.datum);
          if (!bis.isValid() || !datum.isValid()) return true;
          return bis.isSame(datum, 'day') || bis.isAfter(datum, 'day');
        },
        {
          message: t('domain.termine.sheet.validation.laufzeit'),
          path: ['wiederholungBis'],
        },
      );
  }, [t]);
  return validation;
}
